import { render, staticRenderFns } from "./description.vue?vue&type=template&id=d51e5d62&"
import script from "./description.vue?vue&type=script&lang=js&"
export * from "./description.vue?vue&type=script&lang=js&"
import style0 from "./description.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "description.vue"
export default component.exports